<template>
  <div class="test">
    <div class="wrap">
      <div class="model">
        <div class="message">{{ $store.state.message }}</div>
        <div class="btn" @click="query">{{ $t("task.query") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "test",
  methods: {
    query() {
      this.$store.commit("changeModal", "");
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.test {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .model {
      background: white;
      border-radius: 12px;
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      padding: 20px 12px;
      .message {
        text-align: center;
        font-size: 14px;
        color: #333;
      }
      .btn {
        width: 90px;
        margin: 0 auto;
        text-align: center;
        margin-top: 20px;
        background: #f99634;
        height: 30px;
        line-height: 30px;
        padding: 0 12px;
        border-radius: 15px;
        font-size: 12px;
      }
    }
  }
}
</style>